/*
 * @Author: shikexin shikexin0116@163.com
 * @Date: 2022-09-28 16:10:02
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-09-28 16:11:55
 * @FilePath: /www.geekbang.org/src/view/home/data/product.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import config from '@/config'

import logoTime from '@/assets/img/logo/time.png'
import logoTimeSaas from '@/assets/img/logo/time-saas.png'
import logoInfoq from '@/assets/img/logo/infoq.png'
import logoInfoqMeeting from '@/assets/img/logo/infoq-meeting.png'
import logoTgo from '@/assets/img/logo/tgo.png'
import logoResearch from '@/assets/img/logo/research-institute.png'

import timeIntro from '@/assets/img/home/time-intro.png'
import timeSassIntro from '@/assets/img/home/timesaas-intro.png'
import infoqIntro from '@/assets/img/home/infoq-intro.png'
import infoqMeetingIntro from '@/assets/img/home/infoqMeeting-intro.png'
import tgoIntro from '@/assets/img/home/tgo-intro.png'
import researchIntro from '@/assets/img/home/research-intro.png'

import timeIntroH5 from '@/assets/img/home/time-intro-h5.png'
import timeSassIntroH5 from '@/assets/img/home/timesaas-intro-h5.png'
import infoqIntroH5 from '@/assets/img/home/infoq-intro-h5.png'
import infoqMeetingIntroH5 from '@/assets/img/home/infoqMeeting-intro-h5.png'
import tgoIntroH5 from '@/assets/img/home/tgo-intro-h5.png'
import researchIntroH5 from '@/assets/img/home/research-intro-h5.png'

function getProductList (isMobile) {
  return [
    {
      logo: logoTime,
      title: '数字人才的移动知识库',
      titleHtml: '数字人才的移动知识库',
      intro1: '极客时间是数字人才的在线学习平台，通过 PGC 专业内容生产模式，由极客时间教研团队与一线技术专家共同打造，涵盖 70+ 类技术领域。平台提供沉浸式深度学习功能，并通过社群、直播、部落等多种方式，让用户可以与行业大牛零距离交流学习。',
      intro2: '极客时间训练营，聚焦前沿重点技术方向及人才发展的热门趋势，深度还原教育场景，通过“学、练、测、评、答”的系统化教学，帮助用户实现学有所成并学以致用。',
      link: config.timeServer,
      introImg: isMobile ? timeIntroH5 : timeIntro,
      logoHeight: isMobile ? 26 : 38,
      introImgHeight: isMobile ? 217 : 365
    },
    {
      logo: logoTimeSaas,
      title: '企业级一站式数字技术学习平台',
      titleHtml: '企业级一站式<br>数字技术学习平台',
      intro1: '极客时间企业版提供流程化学习体验，系统化学习解决方案和全生命周期的顾问式服务，助力企业打造行业领先的数字人才团队，驱动企业的数字化转型与高质量发展。',
      intro2: '目前已服务 3000+ 家技术驱动型企业，覆盖银行、金融科技、保险、汽⻋、工业制造、互联网、移动通信、软件等行业。',
      link: config.bServer,
      introImg: isMobile ? timeSassIntroH5 : timeSassIntro,
      logoHeight: isMobile ? 26 : 38,
      introImgHeight: isMobile ? 212 : 350
    },
    {
      logo: logoInfoq,
      title: '促进数字技术领域知识与创新的传播',
      titleHtml: '促进数字技术领域<br>知识与创新的传播',
      intro1: 'InfoQ 是一家全球性的在线资讯/社区网站，创立于 2006 年，目前在全球拥有英、法、中、葡、日共五种语言的站点。于 2007 年由极客邦科技创始人兼 CEO 霍太稳引入中国。',
      intro2: 'InfoQ 极客传媒中文站主要面向包括研发团队领导者、CTO、架构师、技术总监和软件开发者在内所有技术人群，总体覆盖技术人群规模达 500 万+。',
      link: config.infoq,
      introImg: isMobile ? infoqIntroH5 : infoqIntro,
      logoHeight: isMobile ? 26 : 40,
      introImgHeight: isMobile ? 186 : 367
    },
    {
      logo: logoInfoqMeeting,
      title: '引领中国数字化实践',
      titleHtml: '引领中国数字化实践',
      intro1: 'InfoQ 技术大会，由一系列面向 IT 从业者，特别是开发者的全球性技术盛会组成，包括 QCon 全球软件开发大会、 ArchSummit 全球架构师峰会、GMTC 全球大前端技术大会、PCon 全球产品创新大会、 DIVE 全球基础软件创新大会、 GTLC 全球技术领导力峰会等。',
      intro2: '大会旨在通过分享时下热⻔的创新技术和实践案例，与技术人群和行业企业一起探讨产品技术团队的组建与管理、技术选型方案、技术对产品和业务的关键作用，以及技术落地等话题。',
      link: config.infoqMeeting,
      introImg: isMobile ? infoqMeetingIntroH5 : infoqMeetingIntro,
      logoHeight: isMobile ? 26 : 40,
      introImgHeight: isMobile ? 280 : 409
    },
    {
      logo: logoTgo,
      title: '科技领导者同侪学习社区',
      titleHtml: '科技领导者同侪学习社区',
      intro1: 'TGO 鲲鹏会致力于把技术领导者和专家连接在一起，通过领导力峰会、专属小组活动、闭⻔沙⻰等形式，为所有 “孤军奋战” 的科技管理者获得自身的成⻓和职业的发展。TGO 鲲鹏会目前拥有近 2000 位高端学员，在全球十多个城市设立分站。',
      link: config.tgo,
      introImg: isMobile ? tgoIntroH5 : tgoIntro,
      logoHeight: isMobile ? 26 : 34,
      introImgHeight: isMobile ? 195 : 338
    },
    {
      logo: logoResearch,
      title: '数字经济观察和数字人才培养',
      titleHtml: '数字经济观察和数字人才培养',
      intro1: '“双数”研究院是极客邦科技的核心研究机构，“双数”指主要研究方向：数字经济观察和数字人才培养。当前聚焦三大重点工作，包括标准建设与企业人才服务生态建设、数字化转型产业人才培养内容研发与推广以及数字化稀缺复合型人才培训内容与模式研究。下设 InfoQ 研究中⼼，主要聚焦在前沿科技领域、数字化产业应⽤和数字⼈才三⽅⾯，旨在加速创新技术的孵化、落地与传播。',
      link: `${config.geekbangServer}/number`,
      introImg: isMobile ? researchIntroH5 : researchIntro,
      logoHeight: isMobile ? 58 : 68,
      introImgHeight: isMobile ? 206 : 431
    }
  ]
}

export {
  getProductList
}
